var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"FormHeader",class:_vm.classNames},[(_vm.title)?_c('h2',{staticClass:"FormHeader__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),(_vm.subtitle)?_c('h5',{staticClass:"FormHeader__subtitle subtitle"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")]):_vm._e(),(!_vm.noSpacing)?_c('div',{class:{
      divider: _vm.divider,
      'mt-4 mb-5': true,
    }}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }